	import { APP_INITIALIZER, NgModule } from '@angular/core';
	import { BrowserModule } from '@angular/platform-browser';
	
	import { AppRoutingModule } from './app-routing.module';
	import { AppComponent } from './app.component';
	import { TilesModule } from './tiles/tiles.module';
	import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
	import { MatSnackBarModule } from '@angular/material/snack-bar';
	import { MatButtonModule } from '@angular/material/button';
	import { MatIconModule } from '@angular/material/icon';
	import { MatMenuModule } from '@angular/material/menu';
	import { FormsModule, ReactiveFormsModule } from '@angular/forms';
	import { RouterModule } from '@angular/router';
	import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
	import { TranslateHttpLoader } from '@ngx-translate/http-loader';
	import { DragDropModule } from '@angular/cdk/drag-drop';
	import { SymbolService } from './service/symbolService';
	import { MatDialogModule } from '@angular/material/dialog';
	import { CommonModule } from '@angular/common';
	import { MatDatepickerModule } from '@angular/material/datepicker';
	import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
	import { MatFormFieldModule } from '@angular/material/form-field';
	import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
	import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { HttpJwtInterceptor } from './helper/httpInterceptor';
import { ErrorInterceptor } from './helper/error.interceptor';
	
	export function HttpLoaderFactory(http: HttpClient) {
	    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
	}
	
	export const DE_DATE_FORMATS = {
	    parse: {
	        dateInput: 'DD.MM.YYYY', // Eingabeformat (z. B. 04.07.2026)
	    },
	    display: {
	        dateInput: 'DD.MM.YYYY', // Anzeigeformat
	        monthYearLabel: 'MMMM YYYY',
	        dateA11yLabel: 'LL',
	        monthYearA11yLabel: 'MMMM YYYY',
	    },
	};
	
	@NgModule({
	    declarations: [
	        AppComponent
	    ],
	    imports: [
	        CommonModule,
	        BrowserModule,
	        BrowserAnimationsModule,
	        AppRoutingModule,
	        TilesModule,
	        HttpClientModule,
	        MatButtonModule,
	        MatMenuModule,
	        MatSnackBarModule,
	        MatDialogModule,
	        MatIconModule,
	        MatDatepickerModule,
	        MatNativeDateModule,
	        MatFormFieldModule,
			MatAutocompleteModule,
	        FormsModule,
	        ReactiveFormsModule,
	        RouterModule,
	        DragDropModule,
	        TranslateModule.forRoot({
	            loader: {
	                provide: TranslateLoader,
	                useFactory: HttpLoaderFactory,
	                deps: [HttpClient]
	            }
	        }),
	    ],
	    providers: [
			{ provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
			{ provide: MAT_DATE_FORMATS, useValue: DE_DATE_FORMATS },
/*	        {
	            provide: APP_INITIALIZER,
	            useFactory: (symbolService: SymbolService) => () => symbolService.init(),
	            deps: [SymbolService],
	            multi: true,
	        },
*/			{ provide: HTTP_INTERCEPTORS, useClass: HttpJwtInterceptor, multi: true },
			{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

	    ],
	    bootstrap: [AppComponent]
	})
	export class AppModule {}
